import { useEffect, useState, useRef } from "react";

const Canvas = ({
  elements,
  setElements,
  selectedId,
  setSelectedId,
  previewMode
}) => {


  // -----add link------
  const handleLinkClick = (el) => {

    if (!previewMode) return

    if (el.link) {
      window.open(el.link, "_blank")
    }

  }


  const [zoom, setZoom] = useState(1)
const frameRef = useRef(null)

  const bannerWidth = 600
  const bannerHeight = 300


  /* ---------------- ZOOM ---------------- */
  useEffect(() => {

const handleDelete = (e) => {

if (e.key !== "Backspace") return
if (previewMode) return
if (selectedId === null || selectedId === undefined) return

const active = document.activeElement
const tag = active.tagName

// Prevent deleting while typing
// If user is typing inside editable text → do not delete element
if (
  active.tagName === "INPUT" ||
  active.tagName === "TEXTAREA" ||
  active.tagName === "SELECT" ||
  active.isContentEditable
) {
  return
}

setElements(prev => {

const element = prev.find(el => el.id === selectedId)
if (!element) return prev

// Only allow backspace delete for BOX
if (element.type !== "box") return prev

// If deleting a box → remove its children too
const collectChildren = (parentId) => {
  return prev
    .filter(el => el.parentBox === parentId)
    .flatMap(child => [child.id, ...collectChildren(child.id)])
}

const idsToDelete =
  element.type === "box"
    ? new Set([selectedId, ...collectChildren(selectedId)])
    : new Set([selectedId])

let remaining = prev.filter(el => !idsToDelete.has(el.id))

/* -------- AUTO SHIFT BOXES -------- */

const gap = 20
let currentX = 20

remaining = remaining.map(el => {

  if (el.type !== "box") return el

  const updated = {
    ...el,
    x: currentX
  }

  currentX += el.width + gap

  return updated
})

return remaining

})

setSelectedId(null)
}


    window.addEventListener("keydown", handleDelete)

    return () => window.removeEventListener("keydown", handleDelete)

  }, [selectedId, previewMode])

  useEffect(() => {

    const handleWheel = (e) => {

      if (!e.ctrlKey) return

      e.preventDefault()

      setZoom(prev => {

        let next = prev - e.deltaY * 0.02

        if (next < 0.3) next = 0.3
        if (next > 3) next = 3

        return next

      })

    }

    window.addEventListener("wheel", handleWheel, { passive: false })

    return () => window.removeEventListener("wheel", handleWheel)

  }, [])



  /* ---------------- AUTO LAYOUT BOXES ---------------- */

  const layoutBoxes = (items) => {

    let x = 20
    const gap = 20

    return items.map(el => {

      if (el.type !== "box") return el

      // IMPORTANT: do not move existing boxes
      if (el.x !== undefined) return el

      const updated = {
        ...el,
        x,
        y: 20
      }

      x += el.width + gap

      return updated

    })

  }

  useEffect(() => {

    setElements(prev => layoutBoxes(prev))

  }, [elements.length])

  useEffect(() => {

    const boxes = elements.filter(e => e.type === "box")

    const needLayout = boxes.some(box => box.x === undefined)

    if (!needLayout) return

    setElements(prev => layoutBoxes(prev))

  }, [elements.length])



  /* ---------------- DRAG ---------------- */

  const startDrag = (e, id) => {

    if (previewMode) return

    e.stopPropagation()

    const element = elements.find(el => el.id === id)

    let startMouseX = e.clientX
    let startMouseY = e.clientY

    let currentX = element.x
    let currentY = element.y

    const move = (event) => {

      const dx = (event.clientX - startMouseX) / zoom
      const dy = (event.clientY - startMouseY) / zoom

      startMouseX = event.clientX
      startMouseY = event.clientY

      let newX = currentX + dx
      let newY = currentY + dy

      const parentBox = elements.find(el => el.id === element.parentBox)

      if (parentBox) {

        const minX = parentBox.x
        const minY = parentBox.y

        const maxX = parentBox.x + parentBox.width - element.width
        const maxY = parentBox.y + parentBox.height - element.height

        newX = Math.max(minX, Math.min(maxX, newX))
        newY = Math.max(minY, Math.min(maxY, newY))

      }

      if (element.type === "box") {

        const minY = 0
        const minX = 10
        const maxY = bannerHeight - element.height
        const maxX = bannerWidth + element.width

        newY = Math.max(minY, Math.min(maxY, newY))
        newX = Math.max(minX, Math.min(maxX, newX))

      }

      const dxMove = newX - currentX
      const dyMove = newY - currentY


if (frameRef.current) return;

frameRef.current = requestAnimationFrame(() => {

  setElements(prev => {

    let updated = prev.map(el =>
      el.id === id
        ? { ...el, x: newX, y: newY }
        : el
    )

    updated = moveChildren(updated, id, dxMove, dyMove)

    return updated
  });

  frameRef.current = null;

});

      const moveChildren = (items, parentId, dx, dy) => {
        return items.map(el => {

          if (el.parentBox === parentId) {
            return {
              ...el,
              x: el.x + dx,
              y: el.y + dy
            }
          }

          return el
        })
      }


      currentX = newX
      currentY = newY

    }

    const stop = () => {
      document.removeEventListener("mousemove", move)
      document.removeEventListener("mouseup", stop)
    }

    document.addEventListener("mousemove", move)
    document.addEventListener("mouseup", stop)

  }



  /* ---------------- RESIZE ---------------- */

const startResize = (e, id, direction) => {
if (previewMode) return;
e.stopPropagation();

const element = elements.find(el => el.id === id);

const startMouseX = e.clientX;
const startMouseY = e.clientY;

const startWidth = element.width;
const startHeight = element.height;
const startX = element.x;
const startY = element.y;

const move = (event) => {

const dx = (event.clientX - startMouseX) / zoom;
const dy = (event.clientY - startMouseY) / zoom;

let newWidth = startWidth;
let newHeight = startHeight;
let newX = startX;
let newY = startY;

/* -------- RIGHT -------- */
if (direction.includes("e")) {
  newWidth = startWidth + dx;
}

/* -------- BOTTOM -------- */
if (direction.includes("s")) {
  newHeight = startHeight + dy;
}

/* -------- LEFT -------- */
if (direction.includes("w")) {
  newWidth = startWidth - dx;
  newX = startX + dx;
}

/* -------- TOP -------- */
if (direction.includes("n")) {
  newHeight = startHeight - dy;
  newY = startY + dy;
}

/* -------- MIN SIZE -------- */
newWidth = Math.max(50, newWidth);
newHeight = Math.max(40, newHeight);

/* -------- KEEP INSIDE PARENT -------- */

const parentBox = elements.find(el => el.id === element.parentBox);

if (parentBox) {

  const parentLeft = parentBox.x;
  const parentTop = parentBox.y;
  const parentRight = parentBox.x + parentBox.width;
  const parentBottom = parentBox.y + parentBox.height;

  // Clamp position
  newX = Math.max(parentLeft, Math.min(newX, parentRight - newWidth));
  newY = Math.max(parentTop, Math.min(newY, parentBottom - newHeight));

  // Clamp size
  newWidth = Math.min(newWidth, parentRight - newX);
  newHeight = Math.min(newHeight, parentBottom - newY);
}

/* -------- BOX LIMIT (CANVAS) -------- */

if (element.type === "box") {

  const minX = 0;
  const minY = 0;
  const maxRight = bannerWidth;
  const maxBottom = bannerHeight;

  // Clamp position
  newX = Math.max(minX, newX);
  newY = Math.max(minY, Math.min(newY, maxBottom - Math.max(40, newHeight)));

  // Clamp size
  newWidth = Math.max(50, newWidth);
  newHeight = Math.max(40, Math.min(newHeight, maxBottom - newY));

  // LEFT boundary
  if (newX < minX) {
    newWidth += newX - minX;
    newX = minX;
  }

  // TOP boundary
  if (newY < minY) {
    newHeight += newY - minY;
    newY = minY;
  }

  // BOTTOM boundary
  if (newY + newHeight > maxBottom) {
    newHeight = maxBottom - newY;
  }

  // final safety
  newWidth = Math.max(50, newWidth);
  newHeight = Math.max(40, newHeight);
}

setElements(prev =>
  prev.map(el =>
    el.id === id
      ? {
          ...el,
          width: newWidth,
          height: newHeight,
          x: newX,
          y: newY
        }
      : el
  )
);

};

const stop = () => {
document.removeEventListener("mousemove", move);
document.removeEventListener("mouseup", stop);
};

document.addEventListener("mousemove", move);
document.addEventListener("mouseup", stop);
};


  /* ---------------- TEXT UPDATE ---------------- */

  const updateText = (id, text) => {

    setElements(prev => prev.map(el => {

      if (el.id === id) {
        return { ...el, text }
      }

      return el

    }))

  }



  /* ---------------- RENDER ELEMENT ---------------- */

  const renderElement = (el) => {

    /* BOX */

    if (el.type === "box") {

      const hasChildren = elements.some(child => child.parentBox === el.id)

      return (
        <div className="box-cont">

          {!hasChildren && selectedId !== el.id && (
            <div className="box-ph">
              Drop Elements Here
            </div>
          )}

        </div>
      )

    }



    /* HEADING */
    if (el.type === "heading") {

      return (

        <div

          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent:
              el.textAlign === "center"
                ? "center"
                : el.textAlign === "right"
                  ? "flex-end"
                  : "flex-start",
            overflow: "hidden"
          }}
        >
          <h1
            contentEditable={!previewMode}
            suppressContentEditableWarning
            onBlur={(e) => updateText(el.id, e.target.innerText)}
            style={{
              fontSize: el.fontSize,
              fontFamily: el.fontFamily,
              color: el.color,
              margin: 0,
              width: "100%",
              height: "100%",
              textAlign: el.textAlign || "left",
              wordBreak: "break-word",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              lineHeight: "1.1"
            }}
          >

            {el.text}

          </h1>

        </div>

      )

    }



    /* TEXT BOX */

    if (el.type === "textBox") {

      return (
        <div
          className="text-box"
          style={{
            width: "100%",
            height: "100%",
            borderRadius: el.borderRadius || 0,
            padding: el.padding || 0,
            background: el.background || "transparent",
            overflow: "hidden"
          }}
        />
      )

    }



    /* IMAGE */

    if (el.type === "image") {

      return (
        <img
          src={el.src}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: el.borderRadius || 0
          }}
        />
      )

    }



    /* BUTTON */

    if (el.type === "button") {

      return (

        <button
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent:
              el.textAlign === "center"
                ? "center"
                : el.textAlign === "right"
                  ? "flex-end"
                  : "flex-start",
            padding: el.padding || 0,
            background: el.background || "#000",
            color: el.color || "#fff",
            borderRadius: el.borderRadius || 0,
            border: "none",
            fontSize: el.fontSize,
            fontWeight: el.fontWeight,
            fontFamily: el.fontFamily || "Inter",
            overflow: "hidden",
            pointerEvents: "none"
          }}
        >

          <span
            contentEditable={!previewMode}
            suppressContentEditableWarning
            onMouseDown={(e) => {
              e.stopPropagation()
              setSelectedId(el.id)
            }}
            onBlur={(e) => updateText(el.id, e.target.innerText)}
            style={{
              outline: "none",
              width: "100%",
              textAlign: el.textAlign || "center", // default center
              wordBreak: "break-word",
              pointerEvents: "auto"
            }}
          >

            {el.text}

          </span>

        </button>

      )

    }
  }



  /* ---------------- CANVAS SIZE ---------------- */

const maxBoxRight = Math.max(
  bannerWidth,
  ...elements.filter(el => el.type === "box").map(el => el.x + el.width + 40)
)



  /* ---------------- UI ---------------- */

  return (

    <div className="can">

      <div className="can-scroll">

        <div
          className="bannerrs"
          style={{
            width: maxBoxRight,
            height: bannerHeight,
            transform: `scale(${zoom})`,
            transformOrigin: "top left",
            position: "relative",
            border: "2px dashed #b7c7ff",
            borderRadius: "20px",
            background: "#dfdfdf"
          }}
        >

          {[...elements]
            .sort((a, b) => {

              if (a.type === "box" && b.type !== "box") return -1
              if (b.type === "box" && a.type !== "box") return 1

              return (a.zIndex || 0) - (b.zIndex || 0)

            })
            .map(el => (

              <div
                key={el.id}
                className={`elementts ${selectedId === el.id ? "selected" : ""}`}
                style={{
                  position: "absolute",
                  transform: `translate(${el.x}px, ${el.y}px) rotate(${el.rotation || 0}deg) scaleX(${el.scaleX || 1}) scaleY(${el.scaleY || 1})`,
                  width: el.width,
                  height: el.height ?? "",
                  background: el.type === "box"
                    ? (el.background || "#ffffff")
                    : "transparent",
                  backgroundImage:
                    el.type === "box" && el.backgroundImage
                      ? `url(${el.backgroundImage})`
                      : "none",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: el.borderRadius || 0,
                  opacity: el.opacity ?? 1,
                  zIndex: el.zIndex || 1,
                  overflow: "hidden",
                  cursor: previewMode && el.link ? "pointer" : "default"
                }}
                onClick={() => handleLinkClick(el)}
                onMouseDown={(e) => {
                  if (previewMode) return
                  setSelectedId(el.id)
                  startDrag(e, el.id)
                }}
              >

                {renderElement(el)}

                {!previewMode && selectedId === el.id && (

                  <>
                  <button
  className="dlt-btn"
  onMouseDown={(e) => {
    e.stopPropagation()

    setElements(prev => {

      const collectChildren = (parentId) => {
        return prev
          .filter(el => el.parentBox === parentId)
          .flatMap(child => [child.id, ...collectChildren(child.id)])
      }

      const idsToDelete =
        el.type === "box"
          ? new Set([el.id, ...collectChildren(el.id)])
          : new Set([el.id])

      return prev.filter(item => !idsToDelete.has(item.id))

    })

    setSelectedId(null)
  }}
>
  ×
</button>

                    {["n", "s", "e", "w", "ne", "nw", "se", "sw"].map(dir => (
                      <div
                        key={dir}
                        className={`resize-handlle resize-${dir}`}
                        onMouseDown={(e) => startResize(e, el.id, dir)}
                      />
                    ))}

                  </>

                )}

              </div>

            ))}

        </div>

      </div>

    </div>

  )

}

export default Canvas